import * as React from 'react';
import { useSearchParams } from 'react-router';

import { FormPrioritySelect } from '#components/FormPrioritySelect.tsx';

export function FormPriority(props: {
  defaultValue?: 'all' | 'required' | 'optional';
}) {
  const [, setSearchParams] = useSearchParams();
  const [value, setValue] = React.useState(props.defaultValue ?? 'all');

  return (
    <FormPrioritySelect
      size="medium"
      value={value}
      onChange={(priority) => {
        setValue(priority);
        setSearchParams((searchParams) => {
          if (priority === 'all') {
            searchParams.delete('fp');
          } else {
            searchParams.set('fp', priority);
          }
          return searchParams;
        });
      }}
      /**
       * An `aria-label` attribute can't be used because the way mui renders a
       * select text field, it applies an `aria-labelledby` attribute which
       * takes precedence over `aria-label`.
       */
      SelectProps={{
        SelectDisplayProps: {
          // @ts-expect-error - TS complains but it works just fine
          'data-testid': 'global-form-priority',
        },
      }}
    />
  );
}
